import { Component, Input } from '@angular/core';
import { PcmProduct } from '@app/sales/modules/subscription/models/pcm-product.model';
import { PriceType } from '@app/shared/pipes/price-format.pipe';
import { PriceFormatPipe } from '../../pipes/price-format.pipe';
import { UniqueSellingPointsComponent } from '../../../sales/modules/subscription/components/subscription-stepper/shared/unique-selling-points/unique-selling-points.component';
import { IcePillComponent } from '../atoms/ice-pill/ice-pill.component';

@Component({
  selector: 'app-vas-information',
  templateUrl: './vas-information.component.html',
  styleUrl: './vas-information.component.scss',
  imports: [IcePillComponent, UniqueSellingPointsComponent, PriceFormatPipe],
})
export class VasInformationComponent {
  @Input({ required: true }) vasProduct: PcmProduct;

  PriceType = PriceType;
}
